import OperatorService from "@/api/services/operator.service";

const UserService = {
  getList(params = { search: "", page: 1, count: 10 }) {
    return OperatorService.get(`/employees`, { headers: params });
  },

  get(id) {
    return OperatorService.get(`/employees/${id}`);
  },

  delete(id) {
    return OperatorService.delete(`/employees/${id}`);
  },

  update(id, newUser) {
    return OperatorService.put(`/employees/${id}`, newUser);
  },

  create(newUser) {
    return OperatorService.post(`/employees`, newUser);
  },
};

export default UserService;
